import { VIMEO_VENUES_HOSTNAME } from '@techchange/components';

/**
 * Parses an embed url to convert it to the correct embed format.
 *
 * @param   {string} src  The original url.
 * @returns {object} url  The converted url with provider.
 */
export default (src) => {
	if (!src) {
		return src;
	}

	let url = src;

	try {
		if (isIframe(src)) {
			url = parseIframeSrc(src);

			return url;
		}

		// Make sure URL is parseable
		if (URL.canParse(src)) {
			// Instantiate new URL
			const urlObject = new URL(url);

			// Check if this is a vimeo embed
			if (urlObject.hostname === VIMEO_VENUES_HOSTNAME) {

				// Check if this is an embed url
				if (urlObject.pathname.indexOf('/embed') === 0) {
					return url;
				}

				// Breakdown parts of the pathname
				const pathnameParts = urlObject.pathname.split('/');

				if (urlObject.pathname.indexOf('/admin') === 0) {

					// If not, generate the correct format
					url = `https://${urlObject.hostname}/embed/${pathnameParts[2]}`;

				} else {
					// If not, the src is the direct venues url
					url = `https://${urlObject.hostname}/embed/${pathnameParts[1]}`;
				}
			}
		}
	} catch (err) {
		console.error('Error parsing iframe URL');
		console.error(err);
	}

	return url;

};

/**
 * Tests a url to determine if it's full html iframe code.
 *
 * @param   {string} src  The original url.
 * @returns {boolean}			Whether the src is an iFrame.
 */
function isIframe(src) {
	const iframeRegex = /<iframe.*?<\/iframe>/si;

	return iframeRegex.test(src);
}

/**
 * Extracts the src from html iframe code.
 *
 * @param   {string} html  The original html.
 * @returns {string} src   The iframe src.
 */
function parseIframeSrc(html) {
	// Instantiate a DOM parser
	const parser = new DOMParser();

	// Generate a DOM representation of the iframe
	const iframeDoc = parser.parseFromString(html, 'text/html');

	// Select the iframe from the DOM
	const iframeElement = iframeDoc.querySelector('iframe');

	// Select the iframe src
	return iframeElement.src;
}
